import React from 'react';

interface BarChartProps {
  percentage: number;
}

const BarChart: React.FC<BarChartProps> = ({ percentage }) => {
  // Definiere die Schritte für die Balken (60%, 65%, ... 100%)
  const steps = Array.from({ length: 9 }, (_, index) => 60 + index * 5);

  // Funktion, um die Hintergrundfarbe basierend auf dem Schritt zu bestimmen
  const getBackgroundColor = (step: number): string => {
    if (percentage >= step) {
      // Hintergrundfarbe für Balken bis zur aktuellen Prozentzahl
      return 'orange';
    }
    // Standardfarbe für nicht betroffene Balken
    return 'lightgray';
  };

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'flex-end',
        height: '120px', // Höhe des Containers anpassen
      }}
    >
      {steps.map((step, index) => (
        <div
          key={index}
          style={{
            flex: '1', // Dynamische Breite basierend auf der Anzahl der Balken
            height: `${60 + index * 5}px`, // Dynamische Höhe basierend auf Schritten
            backgroundColor: getBackgroundColor(step),
            margin: '5px',
            textAlign: 'center',
            color: 'white',
            fontWeight: 'bold',
            lineHeight: '1.5',
            paddingTop: "5px"
          }}
        >
          {step}%
        </div>
      ))}
    </div>
  );
};

export default BarChart;
